import { RequestOptions } from './request-options';

export class MessagesRequest extends RequestOptions {
    IsNew: number;
}




// WEBPACK FOOTER //
// ./src/app/shared/models/messages-request.ts